import _ from "lodash";
import React from "react";
import { useLazyGetMeetingsSummaryQuery } from "../../../services/reminders";

export const MeetingsSummaryContext = React.createContext(null);

export const useMeetingsSummaryData = () => React.useContext(MeetingsSummaryContext)

export const MeetingsSummaryProvider = ({ children, filter = null, isReady = false }) => {
    const [load, { data, error, isLoading, isFetching }] = useLazyGetMeetingsSummaryQuery();

    const reload = () => {
        if (!isReady || !filter || _.isEmpty(filter)) {
            return;
        }
        load({ ...filter }).unwrap();
    };

    React.useEffect(reload, [ filter, isReady ]);

    return (
        <MeetingsSummaryContext.Provider value={{ data, error, isLoading, isFetching }}>
            {children}
        </MeetingsSummaryContext.Provider>
    )
}